import type { FC, ReactNode } from 'react';
import classNames from 'classnames';

import GameTimer from 'app/components/GameTimer';
import Dota2KillIcon from 'app/icons/dota2_kill.svg';
import Dota2TowerIcon from 'app/icons/lol_tower.svg';
import Dota2RoshanIcon from 'app/icons/dota2_roshan.svg';
import { hasField } from 'app/components/DesignVersion/Grad/Blocks/NameBlockGrad/utils';

import style from './style.module.scss';

interface Props {
  team1: AggregatedTeamDota2;
  team2: AggregatedTeamDota2;
  availableFields: Dota2AvailableField[];
  timer: Timer;
}

interface StatDef {
  field: Dota2AvailableField;
  Icon: SVG;
  value: number;
}

const EconomyRow: FC<Props> = ({ team1, team2, availableFields, timer }) => {
  const buildStats = (team: AggregatedTeamDota2): StatDef[] =>
    (
      [
        { field: 'kills', Icon: Dota2KillIcon, value: team.kills },
        { field: 'towers', Icon: Dota2TowerIcon, value: team.towers },
        { field: 'roshans', Icon: Dota2RoshanIcon, value: team.roshans }
      ] as StatDef[]
    ).filter(stat => hasField(availableFields, stat.field));

  const renderStats = (stats: StatDef[]): ReactNode[] =>
    stats.flatMap((stat, index) => {
      const item = (
        <div key={stat.field} className={style.stat}>
          <stat.Icon className={style.statIcon} />
          <span className={style.statValue}>{stat.value}</span>
        </div>
      );
      return index === 0
        ? [item]
        : [<span key={`divider_${stat.field}`} className={style.statDivider} />, item];
    });

  return (
    <div className={style.economy}>
      <div className={style.teamStats}>{renderStats(buildStats(team1))}</div>
      {hasField(availableFields, 'game_timer') && (
        <GameTimer timer={timer} videogame="dota-2" live className={style.timer} />
      )}
      <div className={classNames(style.teamStats, style.teamStatsRight)}>
        {renderStats([...buildStats(team2)].reverse())}
      </div>
    </div>
  );
};

EconomyRow.displayName = 'EconomyRow';

export default EconomyRow;
